<div id="login-page" class="primary-background">
  <div id="login-form">
    <nb-card *ngIf="viewMode == 'VERIFY'">
      <nb-card-header>{{'verification_contact_information'| translation}}</nb-card-header>
      <nb-card-body  class="input-card-body">
        <p>{{'verification_contact_information_additional'| translation}}</p>

        <div class="flex-row flex-between flex-middle" style="align-items: end;margin: 20px 0px;">
          <div class="flex-column-1">
            <p class="list-title"><strong>{{'email'| translation}}</strong></p>
            <p>{{userInfo.email}}</p>
          </div>
          <div class="flex-column-0 align-center">
            <button nbButton status="primary" *ngIf="!userInfo.email_verified && !verificationCode.email.codeSent" (click)="requestVerification('email')">{{'verify'| translation}}</button>
            <p class="verified" *ngIf="userInfo.email_verified"> <span>{{'verified'| translation}}</span>&nbsp;&nbsp;<i class="fas fa-check"></i> </p>
          </div>
        </div>

        <div *ngIf="verificationCode.email.codeSent">
          <p>{{'verification_check_email'| translation}}</p>
          <nb-form-field>
            <input #code="ngModel" [(ngModel)]="verificationCode.email.code" nbInput [placeholder]="'verification_code'| translation" type="text">
            <button style="min-height: 0px;" nbSuffix nbButton status="primary" (click)="sendVerificataion('email')">Submit</button>
          </nb-form-field>
        </div>
        
        <div class="flex-row flex-between flex-middle" style="align-items: end;margin: 20px 0px;">
          <div class="flex-column-1">
            <p class="list-title"><strong>{{'phone_number'| translation}}</strong>&nbsp;<span nbSuffix [nbTooltip]=" 'verification_check_phone_tooltip'| translation "> <i class="fas fa-question-circle"></i> </span></p>
            <p>{{userInfo.phone_number}}</p>
          </div>
          <!-- avoid displaying verify phone number for now -->
          <!-- <div *ngIf='userInfo.phone_number' class="flex-column-0 align-center"> -->
            <!-- <button nbButton status="primary" *ngIf="!userInfo.phone_number_verified && !verificationCode.phone_number.codeSent" (click)="requestVerification('phone_number')">{{'verify'| translation}}</button> -->
            <!-- <p class="verified" *ngIf="userInfo.phone_number_verified"> <span>{{'verified'| translation}}</span>&nbsp;&nbsp;<i class="fas fa-check"></i> </p> -->
          <!-- </div> -->
        </div>
        <div *ngIf="verificationCode.phone_number.codeSent">
          <p>{{'verification_check_phone'| translation}}</p>
          <nb-form-field>
            <input #code="ngModel" [(ngModel)]="verificationCode.phone_number.code" nbInput [placeholder]="'verification_code'| translation" type="text">
            <button nbSuffix nbButton status="primary" (click)="sendVerificataion('phone_number')">{{'submit'| translation}}</button>
          </nb-form-field>
        </div>
        <div class="button-holder">
          <button nbButton (click)="viewMode='EDIT'" status="primary">{{'edit'| translation}}</button>
          &nbsp;&nbsp;
          <button nbButton *ngIf="userInfo.email_verified" status="primary" (click)="navHome()" routerLink="/home">{{'continue'| translation}}</button>
        </div>
      </nb-card-body>
    </nb-card>

    <nb-card *ngIf="viewMode == 'EDIT'">
      <nb-card-header>Update Contact Information</nb-card-header>
      <nb-card-body class="input-card-body">
        <div>
          <nb-form-field id="email-edit">
            <label>{{'email'| translation}}</label>
            <input [(ngModel)]="updatedData.data.email" nbInput [placeholder]="'edit'| translation" type="text">
          </nb-form-field>
        </div>

        <div>
          <app-phone-number [item]="phoneNumberObj" (changed)="phoneNumberChanged($event)"></app-phone-number>
        </div>
        <div class="button-holder">
          <button nbButton (click)="cancelEdit()" status="basic">{{'cancel'| translation}}</button>
          &nbsp;&nbsp;
          <button nbButton (click)="saveNewContact()" status="primary" [disabled]="disableSave">{{'save'| translation}}</button>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
